<template>
  <div>
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>
    <form novalidate class="md-layout" @submit.prevent="validateItem">
      <md-card class="md-layout-item md-size-100 md-small-size-100">
        <md-card-header>
          <div class="md-title">Вход</div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('_username')">
                <label for="_username">Логин</label>
                <md-input
                  class="fixedChrome"
                  type="text"
                  name="_username"
                  id="_username"
                  autocomplete="_username-login"
                  v-model="form._username"
                  :disabled="loading"
                />
                <span class="md-error" v-if="!$v.form._username.required">
                  Логин нужно заполнить
                </span>
              </md-field>

              <md-field :class="getValidationClass('_password')">
                <label for="_password">Пароль</label>
                <md-input
                  class="fixedChrome"
                  type="password"
                  name="_password"
                  id="_password"
                  autocomplete="_password-login"
                  v-model="form._password"
                  :disabled="loading"
                />
                <span class="md-error" v-if="!$v.form._password.required">
                  Пароль нужно заполнить
                </span>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button
            type="submit"
            class="md-primary"
            v-on:click.prevent="validateItem"
            :disabled="loading"
          >
            Вход
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
  import { validationMixin } from "vuelidate";

  import { required } from "vuelidate/lib/validators";
  export default {
    name: "login",
    mixins: [validationMixin],
    data: () => ({
      form: {
        _username: null,
        _password: null,
      },
      loading: false,
    }),
    validations: {
      form: {
        _username: {
          required,
        },
        _password: {
          required,
        },
      },
    },
    methods: {
      getValidationClass: function (fieldName) {
        const field = this.$v.form[fieldName];

        if (field) {
          return {
            "md-invalid": field.$invalid && field.$dirty,
          };
        }
      },
      saveItem: function () {
        this.loading = true;
        this.$store.dispatch("auth/login", this.form).finally(() => {
          this.loading = false;
        });
      },
      validateItem: function () {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.saveItem();
        }
      },
      clearError: function () {
        this.error = {
          code: null,
          message: null,
        };
      },
    },
  };
</script>

<style lang="scss" scoped></style>
